import { render } from "./addDevice.vue?vue&type=template&id=454b17ba"
import script from "./addDevice.vue?vue&type=script&lang=js"
export * from "./addDevice.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__